var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MIME_TYPES } from './const_helper';
import MediaServices from '@/services/MediaService';
import { PRIVATE } from '@/helper/const';
import axios from 'axios';
import config from 'src/config';
import dayjs from 'dayjs';
export function formatBytes(bytes, decimals = 2) {
    if (bytes === 0)
        return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
export function useFormatDate() {
    function formatDate(date, format = 'YYYY/MM/DD hh:ss') {
        if (!date)
            return '';
        return dayjs(date).format(format);
    }
    function formatDateToString(date) {
        if (!date)
            return '';
        return dayjs(date).format('MMM DD YYYY');
    }
    return {
        formatDate,
        formatDateToString,
    };
}
export const copyToClipboard = (str) => {
    navigator.clipboard.writeText(str).then(function () { }, function (err) {
        console.error('Could not copy text: ', err);
    });
};
export const copyPrivateUrl = (file) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { data: { url }, } = yield MediaServices.getSignedUrl({
            altId: file.altId,
            fileId: file._id,
            contentType: file.contentType,
            mode: PRIVATE,
        });
        navigator.clipboard.writeText(url).then(function () { }, function (err) {
            console.error('Could not copy text: ', err);
        });
    }
    catch (error) {
        console.error('Error getting private url', error);
    }
});
export const truncate = (fullStr, strLen = 12, separator) => {
    if (fullStr.length <= strLen)
        return fullStr;
    separator = separator || '...';
    const sepLen = separator.length, charsToShow = strLen - sepLen, frontChars = Math.ceil(charsToShow / 2), backChars = Math.floor(charsToShow / 2);
    return (fullStr.substr(0, frontChars) +
        separator +
        fullStr.substr(fullStr.length - backChars));
};
export const randomId = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
export function formatDate(isoString) {
    // Create a new Date object from the ISO 8601 string
    const date = new Date(isoString);
    // Define an array of month names
    const monthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];
    // Extract the day, month, and year from the Date object
    const day = date.getUTCDate();
    const month = monthNames[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    // Format the date in the desired format
    return `${month} ${day}, ${year}`;
}
export function formatBits(bits) {
    if (bits === 0)
        return '0 bytes';
    const sizes = ['bytes', 'KB', 'MB', 'GB'];
    const k = 1024;
    const i = Math.floor(Math.log(bits) / Math.log(k));
    // Ensure we don't exceed the available sizes array
    const readableValue = parseFloat((bits / Math.pow(k, i)).toFixed(2));
    const unit = sizes[i] || 'bytes';
    return `${readableValue} ${unit}`;
}
export const downloadFile = ({ fileUrl, name, openFileInNewTab, accessToken, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (!fileUrl)
            return false;
        let fileName = name !== null && name !== void 0 ? name : randomId(6);
        // To parse Unsplash images urls for finding the extension
        const parsedUrl = new URL(fileUrl);
        const format = parsedUrl.searchParams.get('fm');
        const path = parsedUrl.pathname;
        let extension = path.match(/\.(\w+)(?=\?|$)/);
        if (extension)
            extension = extension[0];
        fileName = !extension ? `${fileName}.${format}` : name;
        let response;
        if (accessToken)
            response = (yield axios({
                url: fileUrl,
                method: 'GET',
                responseType: 'blob',
                headers: {
                    Authorization: 'Bearer ' + accessToken,
                },
            }));
        else
            response = (yield axios({
                url: fileUrl,
                method: 'GET',
                responseType: 'blob',
            }));
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        if (openFileInNewTab)
            window.open(fileUrl, '_blank');
        window.URL.revokeObjectURL(url);
        return true;
    }
    catch (error) {
        console.error('Failed to download file', error);
        return false;
    }
});
export const getFileExtension = mimeType => {
    const mimeTypes = {
        'text/plain': 'txt',
        'text/html': 'html',
        'application/rtf': 'rtf',
        'text/csv': 'csv',
        'image/png': 'png',
        'image/jpeg': 'jpeg',
        'image/pjpeg': 'jpeg',
        'image/tiff': 'tiff',
        'image/x-tiff': 'tiff',
        'image/webp': 'webp',
        'image/svg+xml': 'svg',
        'image/x-icon': 'ico',
        'image/gif': 'gif',
        'image/jpg': 'jpg',
        'audio/aiff': 'aiff',
        'audio/x-midi': 'midi',
        'audio/x-wav': 'wav',
        'audio/ogg': 'ogg',
        'audio/webm': 'webm',
        'audio/mpeg': 'mp3',
        'audio/x-m4a': 'm4a',
        'application/x-troff-msvideo': 'avi',
        'video/avi': 'avi',
        'video/msvideo': 'avi',
        'video/x-msvideo': 'avi',
        'video/quicktime': 'mov',
        'video/x-quicktime': 'mov',
        'image/mov': 'mov',
        'video/mp4': 'mp4',
        'application/mp4': 'mp4',
        'video/ogg': 'ogv',
        'video/x-ms-wmv': 'wmv',
        'video/x-ms-asf': 'asf',
        'video/webm': 'webm',
        'application/zip': 'zip',
        'application/x-zip': 'zip',
        'application/x-zip-compressed': 'zip',
        'application/x-compress': 'z',
        'application/x-compressed': 'z',
        'multipart/x-zip': 'zip',
        'application/pdf': 'pdf',
        'application/vnd.google-apps.document': 'gdoc',
        'application/doc': 'doc',
        'application/ms-doc': 'doc',
        'application/msword': 'doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
        'application/excel': 'xls',
        'application/vnd.ms-excel': 'xls',
        'application/x-excel': 'xls',
        'application/x-msexcel': 'xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
        'application/x-iwork-numbers-sffnumbers': 'numbers',
        'application/vnd.google-apps.spreadsheet': 'gsheet',
        'application/mspowerpoint': 'ppt',
        'application/powerpoint': 'ppt',
        'application/vnd.ms-powerpoint': 'ppt',
        'application/x-mspowerpoint': 'ppt',
        'application/vnd.google-apps.presentation': 'pptx',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
    };
    return mimeTypes[mimeType] || 'unknown';
};
export const getDownloadUrl = file => {
    const googleDriveMimeTypes = [
        'application/vnd.google-apps.document',
        'application/vnd.google-apps.spreadsheet',
        'application/vnd.google-apps.presentation',
    ];
    let fileUrl = `${config.googleAPIServiceUrl}/${file._id}?alt=media&fm=${getFileExtension(file.contentType)}`;
    if (!googleDriveMimeTypes.includes(file.contentType))
        return fileUrl;
    if (MIME_TYPES['documents']['doc'].includes(file.contentType))
        fileUrl = `${config.googleAPIServiceUrl}/${file._id}/export?mimeType=application/vnd.openxmlformats-officedocument.wordprocessingml.document&fm=${getFileExtension(file.contentType)}`;
    else if (MIME_TYPES['documents']['excel'].includes(file.contentType))
        fileUrl = `${config.googleAPIServiceUrl}/${file._id}/export?mimeType=application/vnd.openxmlformats-officedocument.spreadsheetml.sheet&fm=${getFileExtension(file.contentType)}`;
    else if (MIME_TYPES['documents']['ppt'].includes(file.contentType))
        fileUrl = `${config.googleAPIServiceUrl}/${file._id}/export?mimeType=application/vnd.openxmlformats-officedocument.presentationml.presentation&fm=${getFileExtension(file.contentType)}`;
    return fileUrl;
};
